<div class="app-reset-password">
    <section class="container">
        <div class="center-element">
            <nz-spin nzTip="Loading..." [nzSpinning]="loading">
                <!-- Login Form -->
                <nz-card class="login-card">
                    <div class="card-header">
                        <h1 class="card-header">{{ 'login.reset_password' | translate }}</h1>
                    </div>

                    <form nz-form [formGroup]="resetForm" class="login-form">
                        <!-- Email -->
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="usernameError" [nzSpan]="24" class="form-item">
                                <nz-input-group [nzPrefix]="prefixEmail" class="form-input">
                                    <input
                                        [disabled]="true"
                                        readonly
                                        class="text-input"
                                        type="email"
                                        nz-input
                                        formControlName="email"
                                        [placeholder]="'name@example.com'"
                                        id="username"
                                    />
                                </nz-input-group>
                                <ng-template #prefixEmail><i nz-icon nzType="mail" nzTheme="fill"></i></ng-template>
                                <ng-template #usernameError let-control>
                                    @if (control.hasError('required')) {
                                        {{ 'login.email_required' | translate }}
                                    }
                                    @if (control.hasError('email')) { 
                                        {{ 'login.invalid_email' | translate }}
                                    }
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>

                        <!-- Password -->
                        <nz-form-item class="password-field">
                            <nz-form-control [nzErrorTip]="passwordError" [nzSpan]="24" class="form-item">
                                <nz-input-group [nzPrefix]="prefixPassword" [nzSuffix]="suffixPassword" class="form-input">
                                    <input
                                        class="text-input"
                                        type="password"
                                        nz-input
                                        formControlName="password"
                                        [placeholder]="'login.password' | translate"
                                        id="password"
                                    />
                                </nz-input-group>
                                <ng-template #prefixPassword><i nz-icon nzType="lock" nzTheme="fill"></i></ng-template>
                                <ng-template #suffixPassword
                                    ><i nz-icon nzType="eye" class="view-password" (click)="onViewPassword()"></i
                                ></ng-template>
                                <ng-template #passwordError let-control>
                                    @if (control.hasError('required')) {
                                        {{ 'login.password_required' | translate }}
                                    }
                                    @if (control.hasError('length')) {
                                        {{ 'login.length_required' | translate }}
                                    }
                                    @if (control.hasError('lower')) {
                                        {{ 'login.lower_required' | translate }}
                                    }
                                    @if (control.hasError('upper')) {
                                        {{ 'login.upper_required' | translate }}
                                    }
                                    @if (control.hasError('number')) {
                                        {{ 'login.number_required' | translate }}
                                    }
                                    @if (control.hasError('special')) {
                                        {{ 'login.special_required' | translate }}
                                    }
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>

                        <!-- Confirm Password -->
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="confirmPasswordError" [nzSpan]="24" class="form-item">
                                <nz-input-group [nzPrefix]="prefixConfirmPassword" [nzSuffix]="suffixConfirmPassword" class="common-input">
                                    <input
                                        class="text-input"
                                        type="password"
                                        nz-input
                                        formControlName="confirmPassword"
                                        [placeholder]="'login.confirm_password' | translate"
                                        id="confirmPassword"
                                    />
                                </nz-input-group>
                                <ng-template #prefixConfirmPassword><i nz-icon nzType="lock" nzTheme="fill"></i></ng-template>
                                <ng-template #suffixConfirmPassword
                                    ><i nz-icon nzType="eye" class="view-password" (click)="onViewConfirmPassword()"></i
                                ></ng-template>
                                <ng-template #confirmPasswordError let-control>
                                    @if (control.hasError('required')) {
                                        {{ 'login.confirm_password_required' | translate }}
                                    }
                                    @if (control.hasError('error')) { 
                                        {{ 'login.not_match' | translate }}
                                    }
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                        <br />

                        <!-- Change password btn -->
                        <button nz-button class="common-primary-button w-full" (click)="onChangePassword()">
                            {{ 'login.change_password' | translate }}
                        </button>
                    </form>
                </nz-card>
            </nz-spin>
        </div>
    </section>
</div>
